// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__UawQv","label":"Section_label__3FS0m","contentWrap":"Section_contentWrap__qF80G","footer":"Section_footer__t6ytR","footerInner":"Section_footerInner__1MFV-"};